<template>
  <div id="issueMgContainer">
    <el-row>
      <el-col :span="24">
        <div class="mainHeader">
          问题列表
        </div>
        <div class="mainBody">
          <div class="left" :class="{ showStyleDetail: showDetail }">
            <ul class="mainNav">
              <li v-for="(item, index) in navList" :key="index" :class="{ isActive: active == index }"
                @click.stop="navhandleClick(index)">
                {{ item }}
              </li>
            </ul>
            <div class="issueOpter">
              <el-button :disabled="isIssue" type="primary" size="small" @click="openProbelmStatus">批量处理问题</el-button>
              <el-button :disabled="isPeople" type="primary" size="small" plain @click="openModifyPartyName">
                批量指定责任人
              </el-button>
              <el-button :disabled="isExport" type="primary" size="small" plain @click="acexportExcel">
                导出Excel
              </el-button>
              <div class="filterPerson">
                <span>修改人：</span>
                <el-select v-model="modifiers" placeholder="所有" size="small" multiple :popper-append-to-body="false"
                  @visible-change="modifierKeyReset">
                  <el-input ref="modifierKey1" v-model="modifierKey" placeholder="请输入关键字搜索" size="small"
                    class="selectInput"></el-input>
                  <el-input ref="modifierKey2" slot="empty" v-model="modifierKey" placeholder="无数据" size="small"
                    class="selectInput"></el-input>
                  <el-option v-for="item in modifyUserList" :key="item.value" :label="item.text" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="filterPerson">
                <span>创建人：</span>
                <el-select v-model="creaters" placeholder="所有" size="small" multiple :popper-append-to-body="false"
                  @visible-change="createrKeyReset">
                  <el-input ref="createrKey1" v-model="createrKey" placeholder="请输入关键字搜索" size="small"
                    class="selectInput"></el-input>
                  <el-input ref="createrKey2" slot="empty" v-model="createrKey" placeholder="无数据" size="small"
                    class="selectInput"></el-input>
                  <el-option v-for="item in createUserList" :key="item.value" :label="item.text" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <el-input v-model="searchFileName" placeholder="文件名称、问题描述搜索" size="small" style="width:213px"
                class="searchRight" clearable @input="changeclear" @keyup.enter.native="submitForm">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div>
            <div class="issueTable">
              <checkLabel2D ref="checkLabel2D" :type-array="typeArray" :search-file-name="searchFileName"
                @checkData="checkData" @closeRight="closeRight" @openDetail="openDetail" @setPersonDic="setPersonDic" />
            </div>
          </div>
          <div v-show="showDetail" class="issueDetail">
            <detailItem ref="detailItem" :row-data="rowData" @update="update" @openshowDetail="openshowDetail"
              @closeRight="closeRight" @refresh="refresh" />
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- 导出excel -->
    <el-dialog v-dialogDrag :visible.sync="excelSelectVisiable" :close-on-click-modal="false"
      :close-on-press-escape="false" title="导出excel" width="400px">
      <div v-for="(item, index) in exportExcel" :key="index" class="openModify">
        <el-radio :key="item" v-model="exportExcelradio" :label="item"> {{ item }} </el-radio>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="excelSelectCannel">取 消</el-button>
        <el-button v-loading="excelDisable" type="primary" size="small" @click="excelSelectSure">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 处理问题弹出的数据 -->
    <el-dialog v-dialogDrag :visible.sync="dialogFormVisible" :close-on-click-modal="false"
      :close-on-press-escape="false" title="批量处理问题" width="535px" class="piliangshuli">
      <el-form label-position="left" label-width="110px" size="small">
        <el-form-item label="数据范围：">
          <ul class="dataRangeStyle">
            <li v-for="(item, index) in dataRangelist" :key="index" :class="{ dataRangeSelect: issueSelect == item }"
              @click="changeDataRange(item)">
              {{ item }}
            </li>
          </ul>
        </el-form-item>
        <el-form-item label="处理人身份：">
          <ul class="identityStyle">
            <li v-for="(item, index) in identitylist" :key="index" :class="{ identitySelect: issueidentity == item }"
              @click="changeIdentity(item)">
              {{ item }}
            </li>
          </ul>
        </el-form-item>
        <el-form-item label="问题原始状态：">
          <ul class="prostatusStyle">
            <li v-for="(item, index) in prostatuslist" :key="index" :class="{ prostatusSelect: prostatus == item }"
              @click="changeprostatus(item)">
              {{ item }}
            </li>
          </ul>
        </el-form-item>
        <div class="countStyle">
          符合当前筛选条件的数据共<span>{{ count }}</span>条
        </div>
        <el-form-item label="批量更改问题状态为：" label-width="155px" class="labletop">
          <el-select v-model="selectStatus" filterable placeholder="问题状态" size="small">
            <el-option v-for="item in issueStatus1" :key="item.id" :label="item.cnName" :value="item.id"
              style="width:495px"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="说明:" label-width="50px" class="labletop">
          <el-input v-model="content" type="textarea" style="width:495px" maxlength="200" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="openProbelmStatusCannel">取 消</el-button>
        <el-button type="primary" size="small" @click="openProbelmStatusSure">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 指定提修改放弹出的数据 -->
    <el-dialog v-dialogDrag width="430px" :visible.sync="openModify" :close-on-click-modal="false" :close-on-press-escape="false"
      title="责任人">
      <el-form size="small">
        <el-form-item label="处理问题类型：" label-width="110px">
          <el-radio-group v-model="issueSelect">
            <el-radio label="目前选中"></el-radio>
            <el-radio label="当前页"></el-radio>
            <el-radio label="全部"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="指定责任人：" label-width="110px">
          <el-select v-model="modifierIds" size="small" multiple collapse-tags filterable placeholder="请指定责任人">
            <el-option v-for="(item, index) in ModifyRadios" :key="index" :label="item.name" :value="item.userId">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="openModifyCannel">取 消</el-button>
        <el-button type="primary" size="small" @click="openModifySure">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { checkPermission } from "@/CommonDP/utils/routeAuth";
import checkLabel2D from "./component/2DcheckLabel.vue";
import detailItem from "./component/detailItem.vue";
import requestIssueMg from "@/CommonDP/service/question-service";
import { GetDateTime } from "@/CommonDP/utils/validate";
export default {
  name: "IssueMg",
  components: { checkLabel2D, detailItem },
  data() {
    return {
      updateKey: 0,
      navList: ["全部", "2D问题", "3D问题", "文件问题"],
      active: "0",
      searchFileName: "",
      showDetail: false,
      rowData: {},
      mapType: ["dwg"],
      modelType: ["rvt", "skp", "nwc", "nwd", "ifc", "dgn", "rvm", "ipt", "vue", "glb", "obj", "fbx"],
      fileType: ["doc", "xls", "ppt", "pdf", "txt", "docx", "xlsx", "pptx", "png", "jpg", "gif", "jpeg", "bmp", "tiff"],
      typeArray: [],

      excelSelectVisiable: false, // 导出
      exportExcel: ["目前选中", "当前页", "全部"], // 导出excel
      exportExcelradio: "", // 选中的导出类型
      excelDisable: false,
      multipleSelection: [],
      prjId: "",

      issueSelect: "目前选中",
      content: "",
      dialogFormVisible: false,
      issueidentity: "我是创建人",
      prostatus: "待修改",
      selectStatus: "", // 处理问题选中的问题状态
      issueStatus1: [],
      openModify: false,
      ModifyRadios: [],
      modifierIds: [], // 修改方数据
      ModifyRadiosID: "",
      count: "8",
      dataRangelist: ["目前选中", "当前页", "全部"],
      dataRangelistIsgou: ["目前选中", "当前页", "全部"],
      identitylist: ["我是创建人", "我是修改人"],
      prostatuslist: ["待修改", "已修改", "已复核", "已取消"],
      prostatuslistS: ["待修改", "已修改", "已复核", "已取消"],
      modifiers: [], // 修改人筛选
      modifierKey: "", // 修改人关键字
      modifierList: [], // 修改人字典
      creaters: [], // 创建人筛选
      createrKey: "", // 创建人关键字
      createrList: [] // 创建人字典
    };
  },

  computed: {
    ...mapState({
      prjInfo: (state) => state.projectMg.prjObj,
      messageInfo: (state) => state.XtDesign.messageObj
    }),
    isIssue() {
      return !checkPermission(this.$allPerms.ISSUEMG_ISSUE);
    },
    isPeople() {
      return !checkPermission(this.$allPerms.ISSUEMG_PEOPLE);
    },
    isExport() {
      return !checkPermission(this.$allPerms.ISSUEMG_EXPORT);
    },
    exportParams() {
      const fileTypeList = this.typeArray;
      const data = this.$refs.checkLabel2D;
      const { statusIdList, problemTypeIdList, modifierIdList, qmTypeIdList, specIdList, stageChildIdList, createUserIdList, sourceList } = data.selectForm;
      const params = {
        prjId: this.prjId,
        pageNum: data.page.pageNum,
        pageSize: data.page.pageSize,
        statusIdList,
        fileName: this.searchFileName,
        problemTypeIdList,
        modifierIdList,
        qmTypeIdList,
        specIdList,
        stageChildIdList,
        createUserIdList,
        sourceList,
        idList: [],
        fileTypeList
      };
      return params;
    },
    itemNme() {
      let name = "";
      for (const a of this.issueStatus) {
        if (a.id === this.selectStatus) {
          name = a.cnName;
        }
      }
      return name;
    },
    issueParams() {
      var toStatusid = "";
      for (const a of this.issueStatus) {
        if (a.cnName === this.prostatus) {
          toStatusid = a.id;
        }
      }
      var uodataType = "";
      if (this.issueidentity === "我是创建人") {
        uodataType = "1";
      } else {
        uodataType = "2";
      }
      const fileTypeList = this.typeArray;
      const data = this.$refs.checkLabel2D;
      const { statusIdList, problemTypeIdList, modifierIdList, qmTypeIdList, specIdList, stageChildIdList, createUserIdList, sourceList } = data.selectForm;
      const params = {
        prjId: this.prjId,
        content: this.content,
        statusId: toStatusid,
        statusName: this.prostatus,
        updateType: uodataType,
        toStatusId: this.selectStatus,
        toStatusName: this.itemNme,
        pageNum: data.page.pageNum,
        pageSize: data.page.pageSize,
        statusIdList,
        fileName: this.searchFileName,
        problemTypeIdList,
        modifierIdList,
        qmTypeIdList,
        specIdList,
        stageChildIdList,
        createUserIdList,
        sourceList,
        idList: [],
        fileTypeList
      };
      return params;
    },
    modifyParams() {
      const modifierList = [];
      if (this.modifierIds.length) {
        this.modifierIds.forEach((ele) => {
          const obj = {
            modifierId: ele,
            modifierName: this.ModifyRadios.find((sor) => sor.userId === ele).name
          };
          modifierList.push(obj);
        });
      }
      const data = this.$refs.checkLabel2D;
      const { statusIdList, problemTypeIdList, modifierIdList, qmTypeIdList, specIdList, stageChildIdList, createUserIdList, sourceList } = data.selectForm;
      const params = {
        prjId: this.prjId,
        pageNum: data.page.pageNum,
        pageSize: data.page.pageSize,
        statusIdList,
        fileName: this.searchFileName,
        problemTypeIdList,
        modifierIdList,
        qmTypeIdList,
        specIdList,
        stageChildIdList,
        createUserIdList,
        sourceList,
        idList: [],
        modifierList,
        operType: ""
      };
      return params;
    },
    // 修改人选项列表
    modifyUserList() {
      let list = [...this.modifierList];
      if (this.modifierKey) {
        list = list.filter((item) => {
          return item.text.indexOf(this.modifierKey) !== -1;
        });
      }
      return list;
    },
    // 创建人选项列表
    createUserList() {
      let list = [...this.createrList];
      if (this.createrKey) {
        list = list.filter((item) => {
          return item.text.indexOf(this.createrKey) !== -1;
        });
      }
      return list;
    }
  },
  watch: {
    // 获取焦点
    modifierKey() {
      if (this.modifyUserList.length) {
        this.$nextTick(() => {
          this.$refs.modifierKey1.focus();
        });
      } else {
        this.$nextTick(() => {
          this.$refs.modifierKey2.focus();
        });
      }
    },
    createrKey() {
      if (this.createUserList.length) {
        this.$nextTick(() => {
          this.$refs.createrKey1.focus();
        });
      } else {
        this.$nextTick(() => {
          this.$refs.createrKey2.focus();
        });
      }
    },
    // 修改人和创建人筛选改变
    modifiers(val) {
      this.$refs.checkLabel2D.selectForm.modifierIdList = val;
    },
    creaters(val) {
      this.$refs.checkLabel2D.selectForm.createUserIdList = val;
    }
  },
  created() {
    this.prjId = this.prjInfo.prjId;
    const index = this.$route.query.issueType;
    if (index) {
      this.navhandleClick(index);
    }
  },
  methods: {
    // 设置人员字典数据
    setPersonDic(object) {
      this.modifierList = object.modifierList || [];
      this.createrList = object.createrList || [];
    },
    // 打开下拉框，关键字重置
    modifierKeyReset(val) {
      if (val) this.modifierKey = "";
    },
    createrKeyReset(val) {
      if (val) this.createrKey = "";
    },
    navhandleClick(index) {
      const num = Number(index);
      this.active = num;
      this.showDetail = false;
      this.multipleSelection = [];
      if (num === 1) {
        this.typeArray = this.mapType;
      } else if (num === 2) {
        this.typeArray = this.modelType;
      } else if (num === 3) {
        this.typeArray = this.fileType;
      } else {
        this.typeArray = [];
      }
      this.$nextTick(() => {
        this.$refs.checkLabel2D.getInit();
      });
    },
    openshowDetail() {
      this.showDetail = true;
    },
    // 搜索人员
    changeclear(val) {
      this.searchFileName = val;
      setTimeout(() => {
        this.$refs.checkLabel2D.getInit();
      }, 0);
    },
    refresh() {
      this.$refs.checkLabel2D.refresh();
    },
    openDetail(row) {
      this.rowData = row;
      this.$nextTick(() => {
        this.$refs.detailItem.detailType = "详 情";
        this.$nextTick(() => {
          this.$refs.detailItem.$refs.navdetailVue.getDetailInit(row.questionId, row.prjId, row.fileId);
        });
      });
    },
    update() {
      this.$nextTick(() => {
        this.$refs.checkLabel2D.getInit();
      });
    },
    // 回车
    submitForm() {
      this.$refs.checkLabel2D.getInit();
    },
    closeRight() {
      this.showDetail = false;
    },
    checkData(val) {
      this.multipleSelection = val;
    },
    openProbelmStatus() {
      this.queryDict1();
    },
    // 字典
    queryDict() {
      requestIssueMg.getUserInfoListByPrjId(this.prjId).then((res) => {
        this.ModifyRadios = res.data; // 总修改人
        this.issueSelect = "目前选中";
        this.modifierIds = [];
        this.openModify = true;
      });
    },
    async queryDict1() {
      const res = await requestIssueMg.queryDict(this.prjId);
      if (res.result === "0") {
        this.issueStatus = res.data; // 问题状态
        this.issueidentity = "我是创建人";
        this.prostatus = "待修改";
        this.selectStatus = "";
        this.issueStatus1 = [];
        this.content = "";
        if (this.multipleSelection.length === 0) {
          this.issueSelect = "当前页";
          this.dataRangelist = this.dataRangelistIsgou.slice(1, 3);
        } else {
          this.issueSelect = "目前选中";
          this.dataRangelist = this.dataRangelistIsgou;
        }
        for (var i = 0; i < this.issueStatus.length; i++) {
          if (this.issueStatus[i].cnName === "已取消") {
            this.issueStatus1.push(this.issueStatus[i]);
          }
        }
        await this.queryCount().then((res) => {
          if (res !== false) {
            this.prostatuslist = this.prostatuslistS;
            this.dialogFormVisible = true;
          }
        });
      }
    },
    async queryCount() {
      if (this.issueSelect === "当前页") {
        this.issueParams.idList = this.$refs.checkLabel2D.tabData.map((ele) => ele.questionId);
      } else if (this.issueSelect === "目前选中") {
        this.issueParams.idList = this.multipleSelection.map((ele) => ele.questionId);
      } else {
        this.issueParams.idList = [];
      }
      // if (!this.issueParams.idList?.length) {
      //   this.$warn("请先选中再进行操作");
      //   return false;
      // }
      const res = await requestIssueMg.batchUpdatecount(this.issueParams);
      if (res.result === "0") {
        this.count = res.data;
      }
      return true;
    },
    // 修改人按钮
    openModifyPartyName() {
      this.queryDict();
    },
    acexportExcel() {
      this.exportExcelradio = "目前选中";
      this.excelSelectVisiable = true;
    },
    // 导出取消
    excelSelectCannel() {
      this.excelSelectVisiable = false;
      this.exportExcelradio = "";
    },
    // 导出确定
    excelSelectSure() {
      this.excelDisable = true;
      if (this.exportExcelradio === "目前选中") {
        if (this.multipleSelection.length === 0) {
          this.$message.warning("请选择需要导出的问题");
          this.excelDisable = false;
          return;
        } else {
          this.exportParams.idList = this.multipleSelection.map((ele) => ele.questionId);
        }
      } else if (this.exportExcelradio === "当前页") {
        const data = this.$refs.checkLabel2D.tabData;
        if (data.length === 0) {
          this.$message.warning("暂无数据");
          this.excelDisable = false;
          return;
        } else {
          this.exportParams.idList = this.$refs.checkLabel2D.tabData.map((ele) => ele.questionId);
        }
      } else {
        this.exportParams.idList = [];
      }
      this.exportParams.fileName = "";
      this.exportParams.keyword = this.searchFileName;
      try {
        requestIssueMg.drawingDrawingQuesExport(JSON.stringify(this.exportParams))
          .then((response) => {
            const fileName = "问题列表_" + GetDateTime() + ".xlsx";
            if ("msSaveOrOpenBlob" in navigator) {
            // 兼容ie
              window.navigator.msSaveOrOpenBlob(response, fileName);
              return;
            } else {
              const link = document.createElement("a");
              const blob = response;
              link.style.display = "none";
              link.href = URL.createObjectURL(blob);
              link.setAttribute("download", decodeURI(fileName));
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              this.excelDisable = false;
              this.excelSelectVisiable = false;
            }
          })
          .catch(() => {
            this.excelDisable = false;
          });
      } catch {
        this.excelDisable = false;
      }
    },
    // 切换问题状态 联动得到 批量更改问题状态下拉数据
    changeprostatus(item) {
      this.prostatus = item;
      this.issueStatus1 = [];
      this.selectStatus = "";
      if (this.issueidentity === "我是创建人") {
        if (this.prostatus === "待修改") {
          for (var i = 0; i < this.issueStatus.length; i++) {
            if (this.issueStatus[i].cnName === "已取消") {
              this.issueStatus1.push(this.issueStatus[i]);
            }
          }
        } else if (this.prostatus === "已修改") {
          for (var e = 0; e < this.issueStatus.length; e++) {
            if (this.issueStatus[e].cnName === "待修改" || this.issueStatus[e].cnName === "已复核" || this.issueStatus[e].cnName === "已取消") {
              this.issueStatus1.push(this.issueStatus[e]);
            }
          }
        } else if (this.prostatus === "已复核") {
          for (var f = 0; f < this.issueStatus.length; f++) {
            if (this.issueStatus[f].cnName === "待修改" || this.issueStatus[f].cnName === "已取消") {
              this.issueStatus1.push(this.issueStatus[f]);
            }
          }
        } else if (this.prostatus === "已取消") {
          for (var a = 0; a < this.issueStatus.length; a++) {
            if (this.issueStatus[a].cnName === "待修改") {
              this.issueStatus1.push(this.issueStatus[a]);
            }
          }
        }
      } else {
        if (this.prostatus === "待修改") {
          for (var b = 0; b < this.issueStatus.length; b++) {
            if (this.issueStatus[b].cnName === "已修改" || this.issueStatus[b].cnName === "已取消") {
              this.issueStatus1.push(this.issueStatus[b]);
            }
          }
        } else if (this.prostatus === "已修改") {
          for (var c = 0; c < this.issueStatus.length; c++) {
            if (this.issueStatus[c].cnName === "待修改" || this.issueStatus[c].cnName === "已取消") {
              this.issueStatus1.push(this.issueStatus[c]);
            }
          }
        } else if (this.prostatus === "已复核") {
          for (var d = 0; d < this.issueStatus.length; d++) {
            if (this.issueStatus[d].cnName === "已取消") {
              this.issueStatus1.push(this.issueStatus[d]);
            }
          }
        } else if (this.prostatus === "已取消") {
          for (const iterator of this.issueStatus) {
            if (iterator.cnName === "待修改") {
              this.issueStatus1.push(iterator);
            }
          }
        }
      }
      this.queryCount();
    },
    // 问题处理 取消
    openProbelmStatusCannel() {
      this.dialogFormVisible = false;
    },
    openProbelmStatusSure() {
      this.batchProcessing();
    },
    // 批量操作  问题处理
    async batchProcessing() {
      if (this.issueSelect === "目前选中") {
        if (this.multipleSelection.length === 0) {
          this.$message.warning("请选择需要修改的问题");
          this.dialogFormVisible = false;
          return;
        } else {
          this.issueParams.idList = this.multipleSelection.map((ele) => ele.questionId);
        }
      } else if (this.issueSelect === "当前页") {
        const data = this.$refs.checkLabel2D.tabData;
        if (data.length === 0) {
          this.$message.warning("暂无数据");
          return;
        } else {
          this.issueParams.idList = this.$refs.checkLabel2D.tabData.map((ele) => ele.questionId);
        }
      } else {
        this.issueParams.idList = [];
      }
      const result = await requestIssueMg.DrawingQuestionStatusBatchEdit(this.issueParams);
      if (result.result === "0") {
        this.dialogFormVisible = false;
        this.$message.success(`共${result.data}条数据修改成功`);
        this.$nextTick(() => {
          this.$refs.checkLabel2D.getInitOld();
        });
      }
    },
    // 修改人 取消
    openModifyCannel() {
      this.openModify = false;
    },
    // 修改人 确定
    openModifySure() {
      if (!this.modifierIds || this.modifierIds.length === 0) {
        this.$message({ message: "请选择指定责任人", type: "warning" });
        return;
      } else {
        this.ModifyBatchProcessing();
      }
    },
    async ModifyBatchProcessing() {
      if (this.issueSelect === "目前选中") {
        if (this.multipleSelection.length === 0) {
          this.$message.warning("请选择需要指定责任人的问题");
          this.dialogFormVisible = false;
          return;
        } else {
          this.modifyParams.idList = this.multipleSelection.map((ele) => ele.questionId);
        }
      } else if (this.issueSelect === "当前页") {
        const data = this.$refs.checkLabel2D.tabData;
        if (data.length === 0) {
          this.$message.warning("暂无数据");
          return;
        } else {
          this.modifyParams.idList = this.$refs.checkLabel2D.tabData.map((ele) => ele.questionId);
        }
      } else {
        this.modifyParams.idList = [];
      }
      const result = await requestIssueMg.DrawingQuestionquesti(this.modifyParams);
      if (result.result === "0") {
        this.openModify = false;
        // 请求成功啦，再次读取数据
        this.$message.success("修改成功");
        this.$nextTick(() => {
          this.$refs.checkLabel2D.getInitOld();
        });
      }
    },
    changeDataRange(item) {
      console.log(item);
      this.issueSelect = item;
      this.queryCount();
    },
    // 切换处理人身份 问题状态一直保持待处理
    changeIdentity(item) {
      this.issueidentity = item;
      this.prostatuslist = this.prostatuslistS;
      this.prostatus = "待修改";
      this.changeprostatus("待修改");
    }
  }
};
</script>
<style lang="scss" scoped>
#issueMgContainer {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  overflow: auto;
  position: relative;
  background-color: #fff;
  .el-row {
    width: 100%;
    height: 100%;
    .el-col {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      position: relative;
    }
  }
  .mainHeader {
    width: 100%;
    padding: var(--middle-space) var(--big-space);
    box-sizing: border-box;
    font-size: 16px;
    color: var(--key-color);
    font-weight: 600;
    border-bottom: 1px solid rgba(211, 217, 232, 0.77);
  }
  .mainBody {
    width: 100%;
    height: 1px;
    flex-grow: 1;
    display: flex;
    flex-direction: row;
    // position: relative;
    .left {
      width: 100%;
      height: 100%;
      transition: all 0.3s;
      display: flex;
      flex-direction: column;
    }
    .showStyleDetail {
      width: calc(100% - 428px);
      height: 100%;
      transition: all 0.3s;
    }
    .mainNav {
      width: 100%;
      height: 45px;
      padding: 0 var(--big-space);
      border-bottom: 1px solid #e8ebef;
      display: flex;
      flex-direction: row;
      box-sizing: border-box;
      // justify-content: space-between;
      align-items: center;
      font-size: 16px;
      li {
        width: 80px;
        box-sizing: border-box;
        height: 100%;
        line-height: 45px;
        cursor: pointer;
        margin-right: var(--small-space);
        font-size: 14px;
        user-select: none;
        text-align: center;
      }
      .isActive {
        color: var(--theme-color);
        border-bottom: 2px solid var(--theme-color);
        // transition: all .3s;
      }
    }
    .issueOpter {
      width: 100%;
      padding: var(--middle-space) var(--big-space);
      display: flex;
      flex-direction: row;
      align-items: center;
      box-sizing: border-box;
      .searchRight {
        margin-left: auto;
      }
    }
    .issueTable {
      width: 100%;
      height: 1px;
      flex-grow: 1;
    }
    .issueDetail {
      width: 438px;
      height: 100%;
      border-left: 1px solid #f5f5f5;
      box-sizing: border-box;
      z-index: 10;
      overflow: auto;
    }
  }
}
.openModify,
.excelType {
  width: 500px;
  padding-bottom: 10px;
}
.excelType {
  border-bottom: 1px dashed #ccc;
}
.piliangshuli {
  /deep/ .el-form-item {
    margin-bottom: 8px !important;
  }
  /deep/ .el-dialog__body {
    padding: 10px 20px;
    box-sizing: border-box;
  }
  /deep/ .el-button--primary {
    background: var(--theme-color);
    border-color: var(--theme-color);
  }
  /deep/ .el-button--primary:hover {
    background: #7397ec;
    border-color: #7397ec;
  }
  .labletop {
    /deep/ .el-form-item__label {
      float: none !important;
      display: inline-block !important;
      text-align: left !important;
    }
    /deep/ .el-form-item__content {
      margin-left: 0 !important;
    }
    /deep/ .el-select {
      width: 495px;
    }
    /deep/ .el-textarea__inner {
      height: 150px;
    }
  }
  li {
    border: 1px solid #bdc7da;
    height: 28px;
    line-height: 26px;
    text-align: center;
    border-radius: 20px;
    color: var(--key-color);
    display: inline-block;
    margin-right: 12px;
    background: #fff;
    cursor: pointer;
  }
  .dataRangeStyle {
    li {
      width: 72px;
    }
    .dataRangeSelect {
      background: rgba(56, 115, 254, 0.1);
      border: 1px solid var(--theme-color);
      color: var(--theme-color);
    }
  }
  .identityStyle {
    li {
      width: 92px;
    }
    .identitySelect {
      background: rgba(56, 115, 254, 0.1);
      border: 1px solid var(--theme-color);
      color: var(--theme-color);
    }
  }
  .prostatusStyle {
    li {
      width: 66px;
    }
    .prostatusSelect {
      background: rgba(56, 115, 254, 0.1);
      border: 1px solid var(--theme-color);
      color: var(--theme-color);
    }
  }
  .countStyle {
    height: 44px;
    line-height: 44px;
    background: rgba(212, 217, 236, 0.21);
    color: var(--theme-color);
    text-align: center;
    font-size: 14px;
    margin-top: 22px;
    margin-bottom: 10px;
    span {
      color: #ee4c4c;
    }
  }
}
.filterPerson {
  margin-left: 20px;
  display: flex;
  align-items: center;

  span {
    font-size: 14px;
  }
}
</style>
